// extracted by css-extract-rspack-plugin
export default {"title":"title-Pf7EdS text-5xl-semibold","description":"description-GZ07LK text-xl-light","signInButton":"signInButton-HcmsNV"};